import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';


export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box sx={{ maxWidth: 640, mx: 'auto', p: 3 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>Page introuvable</Typography>
        <Typography sx={{ mb: 3 }}>Cette fonctionnalité ou cette adresse n'existe pas.</Typography>
        <Button variant="contained" onClick={() => navigate('/')}>Retour à la recherche</Button>
      </Paper>
    </Box>
  );
}
